<template>
  <div class="m-footer">
    <div class="m-footer-top">
      <div class="m-footer-connect">
        <p class="connect-title">关于我们</p>
        <div class="connect-item">
          <span @click="goAboutUs('introduce')">企业简介</span>
          <span @click="goAboutUs('connect')">联系我们</span>
        </div>
      </div>
      <div class="m-footer-code">
        <div class="aixue">
          <div class="code-wrap">
            <img class="code" src="../../../assets/images/ax.png" alt="">
            <span>爱学</span>
          </div>
          <div class="promise">
            郑重承诺：<br/>
            爱学App不向学前儿童、中小学生提供校外学科类培训服务<br/>
            爱学App不能用于违规学科培训<br/>
            爱学App仅面向学校或者教育行政部门提供服务，<br/>
            不对社会机构和个人提供服务<br/>
          </div>
        </div>
        <div class="aixuepai">
          <div class="code-wrap">
            <img class="code" src="../../../assets/images/axp.png" alt="">
            <span>爱学派</span>
          </div>
          <div class="promise">
            郑重承诺：<br/>
            爱学派App不向学前儿童、中小学生提供校外学科类培训服务<br/>
            爱学派App不能用于违规学科培训<br/>
            爱学派App仅面向学校或者教育行政部门提供服务，<br/>
            不对社会机构和个人提供服务<br/>
          </div>
        </div>
      </div>
    </div>
    <div class="m-footer-record">
      <p>
        <a href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=11010202007369" target="_blank">京公网备案 11010202007369</a>
        <a href="http://beian.miit.gov.cn/" target="_blank">&nbsp;&nbsp;京ICP备10032123号</a><br/>
        <a :href="`${urlOrigin}/#/icp`" target="_blank">&nbsp;&nbsp;京ICP证061033号</a>
      </p>
      <p>Copyright ©{{curYear}} 北京四中龙门网络教育技术有限公司</p>
      <p>投诉电话 010-82082260<br/>投诉邮箱 tousu@etiantian.com</p>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      curYear: new Date().getFullYear(),
      urlOrigin: window.location.origin
    }
  },
  methods: {
    goAboutUs(id) {
      let url = this.$router.resolve({
        path: '/mett/about'
      })
      let jumpUrl = url.href + '?id=' + id
      window.open(jumpUrl, '_blank')
    },
  }
}
</script>
<style lang="scss" scoped>
.m-footer {
  width: 100%;
  padding-top: .74rem;
  background: linear-gradient(135deg, #1647BD, #246BCB, #30AAF8);
  .m-footer-top {
    width: calc(100% - .72rem);
    border-bottom: 1px solid #F7F8F8;
    margin: 0 .32rem 0 .4rem;
    padding-bottom: .48rem;
    .m-footer-connect {
      display: flex;
      font-size: .25rem;
      font-weight: 400;
      color: #A0C6E0;
      line-height: .26rem;
      margin-right: 1rem;
      margin-bottom: .58rem;
      .connect-title {
        font-weight: 400;
        color: #F7F8F8;
        margin-right: .32rem;
      }
      span {
        display: block;
        margin-bottom: .26rem;
      }
    }
    .m-footer-code {
      flex-grow: 1;
      .code-wrap {
        display: flex;
        align-items: flex-end;
        font-size: .33rem;
        font-weight: 400;
        color: #FFFFFF;
        margin-bottom: .3rem;
        .code {
          width: 1.26rem;
          height: 1.26rem;
          border-radius: .04rem;
          margin-right: .12rem;
        }
      }
      .promise {
        width: 100%;
        font-size: .25rem;
        font-weight: 400;
        color: #CDD3ED;
        line-height: .33rem;
      }
    }
    .m-footer-code {
      .aixuepai {
        margin-top: .48rem;
        .code-wrap {
          .code {
            padding: .04rem;
            background: #fff;
          }
        }
      }
    }
  }
  .m-footer-record {
    padding: .28rem 0 .48rem 0;
    text-align: center;
    font-size: .25rem;
    font-weight: 400;
    color: #F7F8F8;
    line-height: .38rem;
  }
}
</style>